var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00006 11.2256C0.997137 10.5161 1.12787 9.8129 1.38474 9.15623C1.64161 8.49956 2.01961 7.90226 2.49716 7.39844C2.97471 6.89461 3.54244 6.49413 4.16794 6.21987C4.79345 5.94561 5.46444 5.80294 6.14266 5.8V5.8C6.54665 5.79953 6.94157 5.67454 7.27805 5.44063C7.61452 5.20671 7.87763 4.87425 8.03454 4.48479L8.43756 3.4936C8.73517 2.75588 9.23367 2.12608 9.87101 1.68267C10.5083 1.23926 11.2563 1.00184 12.0217 1H15.9791C16.7445 1.00184 17.4924 1.23926 18.1297 1.68267C18.7671 2.12608 19.2656 2.75588 19.5632 3.4936L19.9662 4.48479C20.1231 4.87412 20.3861 5.2065 20.7224 5.44041C21.0587 5.67431 21.4535 5.79937 21.8573 5.8V5.8C22.5356 5.80294 23.2066 5.94561 23.8321 6.21987C24.4576 6.49413 25.0253 6.89461 25.5028 7.39844C25.9804 7.90226 26.3584 8.49956 26.6153 9.15623C26.8721 9.8129 27.0029 10.5161 26.9999 11.2256V18.1432C27.0069 19.9541 26.326 21.6938 25.1071 22.9796C23.8882 24.2654 22.231 24.9922 20.5 25H7.50003C5.76889 24.9922 4.11162 24.2653 2.89268 22.9793C1.67373 21.6933 0.992942 19.9535 1.00006 18.1424V11.2256Z",
    stroke: "#ACBBC5",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 9.85634C11.8015 9.85634 10.0191 11.721 10.0191 14.0211C10.0191 16.3213 11.8015 18.1859 14.0002 18.1859C16.1988 18.1859 17.9812 16.3213 17.9812 14.0211C17.9812 11.721 16.1988 9.85634 14.0002 9.85634Z",
    stroke: "#ACBBC5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2db1df7e2818aab50f03f1516d95b310.svg";
export { ForwardRef as ReactComponent };